import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'unistore/react'
import store from './helpers/store'
import './index.css'
import { init as initI18n } from './Services/i18n.jsx'
import AppContactForm from './AppContactForm.jsx'
import AppContactFormInterpreting from './AppContactFormInterpreting.jsx'
import AppLoginMobile from './AppLoginMobile.jsx'
import AppLogin from './AppLogin.jsx'
import AppInstantQuote from './AppInstantQuote.jsx'

import './helpers/marketing-cookies'
import { WIDGET_IDS } from '../widget.config.js'

initI18n()

// Cambia SOLO questa riga per scegliere quale widget buildare.
// vite.config.js parsa questo identificatore e ne deriva fileName/name + l'id del <div> in index.html.
const ActiveWidget = AppContactFormInterpreting

const widgetId = WIDGET_IDS[ActiveWidget.displayName || ActiveWidget.name] || import.meta.env.VITE_WIDGET_ID
if (!widgetId) {
    console.error('[main] Nessun id widget risolto. Aggiorna widget.config.js.')
}

const container = widgetId ? document.getElementById(widgetId) : null
if (container) {
    const root = ReactDOM.createRoot(container)
    root.render(
        <Provider store={store}>
            <ActiveWidget />
        </Provider>
    )
}
